import request from '@/utils/httpRequest'

export default class QualityTaskService {
  queryQualityTaskById(id) {
    return request({
      url: '/ding/quality/task/queryQualityTaskById',
      method: 'get',
      params: { id: id }
    })
  }
  startFlow(params) {
    return request({
      url: '/quality/wuyeQualityTask/startFlow',
      method: 'post',
      data: params
    })
  }

}
